<template>
  <div class="SocialLinks">
    <a v-for="{ icon, text, url } in items"
      :key="text"
      :href="url"
      :aria-label="text"
      class="link"
      target="_blank"
    >
      <component :is="`svg-social-icons-${icon}`" />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>

.SocialLinks {
  display: flex;
  align-items: center;
  column-gap: var(--spacing-6);
}

.link {
  color: var(--text-color-muted);
  transition: color 0.15s;
}

.link:hover {
  color: var(--text-color-white);
}
</style>
